import { Box, Link } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

export default function LinkFileRedirectDownload({
    id,
    nome
}: LinkFileRedirectDownloadProps) {

    const { token } = useContext(AuthContext);

    return (
        <Box display="flex" gap={1} alignItems="center">
            <AttachFileIcon sx={{ fontSize: 14 }} />

            <Link
                rel="noopener"
                target="_blank"
                variant="caption"
                href={`${process.env.REACT_APP_API}/api/baixar-arquivo/${id}?token=${token}`}
            >
                {nome}
            </Link>
        </Box>
    )
}

interface LinkFileRedirectDownloadProps {
    id: number,
    nome: string
}